export default {
    props: {
        headers: {
            type: Object,
            default: function () {
                return {
                    Authorization: localStorage.getItem('token')
                }
            }
        }
    }
}